import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import {ms} from '../../styles/normalizeSize';
import {Text} from '../Text';
import {
  textBase,
  Container as TextInputContainer,
  ErrorText as TextInputErrorText,
  native as textInputNative,
  web as textInputWeb,
} from '../TextInput/styles';

const base = css<StyledProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${ms(47)};
  height: ${'auto'};
`;

export const web = css<StyledProps>`
  box-sizing: border-box;
  ${textInputWeb}
  ${base}
`;

export const native = css<StyledProps>`
  ${textInputNative}
  ${base}
`;

export const TextInputLikeText = styled(Text)<StyledProps>`
  ${textBase}
`;

export const Container = styled(TextInputContainer)``;

export const ErrorText = styled(TextInputErrorText)`
  left: ${ms(15)};
  right: ${ms(15)};
`;
